import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useCompanyCollectionContext } from './useCompanyCollection'
import { activeCompanies, filterByTab } from '../model/company-collection'

/**
 * View-model for the companies list. Surfaces the rows for the selected tab and
 * the active-company count (used to block deactivating the last active company),
 * both derived from the collection via the pure filters in the functional core.
 *
 * Lives in `composables/` so the View consumes the core through the blessed
 * MVVM indirection rather than value-importing `model/` directly.
 */
export function useCompanyList(activeTab: MaybeRefOrGetter<string>) {
  const collection = useCompanyCollectionContext()!
  const companiesFiltered = computed(() =>
    filterByTab(collection.companies.value, toValue(activeTab))
  )
  const activeCompanyCount = computed(
    () => activeCompanies(collection.companies.value).length
  )
  return { companiesFiltered, activeCompanyCount }
}
